const NAMESPACE = "pc-table";

const KEYS = {
    orderByLabel: "orderByLabel",
    itemsPerPageMessage: "itemsPerPageMessage",
    customItemsPerPageOption: "customItemsPerPageOption",
    emptyTextDefault: "emptyTextDefault"
};

const MESSAGES = {
    [KEYS.orderByLabel]: {
        value: "Order by",
        comment: "Label for the order by selector"
    },
    [KEYS.itemsPerPageMessage]: {
        value: "Items per page:",
        comment: "Label for the items per page selector"
    },
    [KEYS.customItemsPerPageOption]: {
        value: "Custom",
        comment: "Text for the custom items per page selector option"
    },
    [KEYS.emptyTextDefault]: {
        value: "No data available.",
        comment: "Default text to show when the project table is empty"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
